import React from "react";
import { ExternalLink, IExternalLinkProps } from "../external-link";
import { IParagraphProps, ParagraphGroup } from "../paragraph-group";
import style from "./style.module.css";

export interface IParagraphTwinsProps {
    p1: IParagraphProps;
    p2: IParagraphProps
    link1?: IExternalLinkProps;
    link2?: IExternalLinkProps;
}

export function ParagraphTwins(props: IParagraphTwinsProps) {
    return (
        <section className={style.twins}>
            <section className={style.sibling}>
                <ParagraphGroup
                    {...props.p1}
                    groupStyle={style.paragraphGroup}
                />
                {
                    props.link1 ?
                    <ExternalLink
                        {...props.link1}
                    />:
                    null
                }
            </section>
            <section className={style.sibling}>
                <ParagraphGroup
                    {...props.p2}
                    groupStyle={style.paragraphGroup}
                />
                                {
                    props.link2 ?
                    <ExternalLink
                        {...props.link2}
                    />:
                    null
                }
            </section>
        </section>

    )
}